import { get } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { getActiveOperationUuid } from 'current/selectors';
import { allOperationsSelected } from 'constants/operations';

export const getAllFields = (state) => get(state, 'fields');

export const getAllFieldUuids = (state) => Object.keys( get(state, 'fields.byUuid', {}) );

export const getFieldByUuid = (state, fieldUuid) => get(state, `fields.byUuid.${fieldUuid}`);

export const getFieldIdByUuid = (state, fieldUuid) => get(state, `fields.byUuid.${fieldUuid}.id`);
export const getFieldUuidById = (state, fieldId) => get(state, `fields.byId.${fieldId}.uuid`);

export const getFieldsForOperation = (state, operationId) => {
  const fieldsByUuid = Object.values(get(state, 'fields.byUuid'));
  return operationId  === allOperationsSelected 
    ? fieldsByUuid
    : fieldsByUuid.filter(field => field.operationId === operationId); 
};

export const getFieldIdsForOperation = (state, operationUuid) => {
  const fields = getFieldsForOperation(state, operationUuid);
  return fields.map((field) => parseInt(field.id, 10));
};

export const getFieldsForOperationSortedByName = (state, operationUuid) => {
  const fields = getFieldsForOperation(state, operationUuid);
  fields.sort( (fieldA, fieldB) => {
    const a = fieldA.name.toLowerCase();
    const b = fieldB.name.toLowerCase();

    if (a === b) {
      return 0;
    }
    return (a < b) ? -1 : 1;
  });
  return fields;
};

export const getFieldsForFieldSelector = createSelector([
  (state) => getActiveOperationUuid(state),
  (state) => state.fields.byUuid
],
(activeOperationUuid, allFields) => {
  const fields = (activeOperationUuid === allOperationsSelected) || !Boolean(activeOperationUuid)
    ? Object.values(allFields) 
    : Object.values(allFields).filter(({ operationId }) => operationId === activeOperationUuid);

  return fields.sort((fieldA, fieldB) => fieldA.name.localeCompare(fieldB.name)); 
});

export const getFieldsForOperations = createSelector([
  state => Object.values(state.fields.byUuid),
  (_, operationIds) => operationIds
],
(fields, operationIds) => {
  return operationIds === allOperationsSelected 
    ? fields
    : fields.filter(({ operationId }) => operationIds.includes(operationId));
});

export const getFieldsUuidsForActiveOperation = createSelector([
  state => getActiveOperationUuid(state),
  state => state.fields.byUuid
],
(activeOperation, fields) => {
  return activeOperation === allOperationsSelected
    ? Object.keys(fields)
    : Object.values(fields).filter(({ operationId }) => operationId === activeOperation).map(({ uuid }) => uuid);
});
